import React from 'react'
import { useNavigate } from 'react-router-dom';

const LogoutButton = () => {
    const navigate = useNavigate()
    const logout = () => {
        localStorage.removeItem('token');
        navigate('/login');
    }
    return (
        <div style={{width:"100%",display:"flex",justifyContent:"space-between",alignItems:"center"}} >
            <h1 style={styles.header}>Admin Panel</h1>

            <div onClick={logout}>

                <button style={styles.button}>Logout</button>
            </div>
        </div>
    )
}

const styles = {
    button: {
        fontFamily: "MonMedium",
        background: "#003366",
        color: "#fff",
        border: "none",
        borderRadius: "4px",
        padding: "8px 12px",
        cursor: "pointer",
    },
    header: {
        fontFamily: "MonBold",
        fontSize: "24px",
        marginBottom: "20px",
    },
}

export default LogoutButton